import React from "react";
import { Modal } from "rsuite";
import { Button } from "../../../../components";
import { formatInTimeZone } from "date-fns-tz";

export default function PdfModal({ open, onOpen, onClose, pdfUrl, rowData, timeZone }) {
  return (
    <Modal open={open} onOpen={onOpen} onClose={onClose} size="85vw" width="80%">
      <Modal.Header>
        <Modal.Title>
          {rowData.emailSubject} -{" "}
          {rowData.emailReceivedDate ? formatInTimeZone(new Date(rowData.emailReceivedDate), timeZone, "dd/MM/yyyy HH:mm:ss") : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: "75vh", width: "100%" }}>
        {pdfUrl && (
          <embed
            type="application/pdf"
            src={pdfUrl}
            style={{ width: "100%", height: "calc(100% - 10px)" }}
            frameBorder="0"
            title="PDF Viewer"
            sandbox="allow-scripts allow-same-origin"
          />
        )}
      </Modal.Body>{" "}
      <Modal.Footer style={{ paddingTop: 0 }}>
        <Button onClick={onClose} text="Close" />
      </Modal.Footer>
    </Modal>
  );
}
